/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */

export default {
  data () {
    return {
      widgetsProperties: {},
      reviewTab: {
        'title': 'Review Tab',
        'short_description': 'The Review Tab is a standalone tab which can be displayed on any page of your site. Clicking the Review Tab will open a light box in the center of the screen which displays your reviews.',
        'properties': [
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '600px x 500px',
                  'value': 'desktop',
                  'display_input': false,
                  'class': 'dimensions',
                  'id': ''
                }]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Fit to screen',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Review Tab',
            'prop_class': 'review_tab',
            'prop_desc': 'Customise the display of your Review Tab.',
            'prop_option': [
              {
                'title': 'Position my Tab',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Left of the screen',
                  'value': 'left',
                  'name': 'tab_position',
                  'display_input': true,
                  'class': 'tab_position',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Right of the screen',
                  'value': 'right',
                  'display_input': true,
                  'name': 'tab_position',
                  'class': 'tab_position',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Tab colour',
                'prop_class': 'tab_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'tab_color',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'tab_color',
                  'id': ''
                }]
              },
              {
                'title': 'Tab opacity',
                'prop_class': 'tab_opacity',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '25%',
                  'value': 25,
                  'name': 'tab_opacity',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': '50%',
                  'value': 50,
                  'name': 'tab_opacity',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }, {
                  'type': 'radio',
                  'label': '75%',
                  'value': 75,
                  'display_input': true,
                  'name': 'tab_opacity',
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_3'
                }, {
                  'type': 'radio',
                  'label': '100%',
                  'value': 100,
                  'name': 'tab_opacity',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_4'
                }
                ]
              },
              {
                'title': 'Tab font colour',
                'prop_class': 'font-color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#ffffff',
                  'value': 'left',
                  'name': 'font_color',
                  'display_input': false,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'class': 'font_color',
                  'id': 'font_color'
                }]
              }

            ]
          },
          {
            'prop_title': 'Widget header',
            'prop_class': 'widget_header',
            'prop_wrapper': 'flex',
            'prop_desc': 'Customise the header of your widget to what you want your customers to see. ',
            'prop_option': [
              {
                'title': 'Widget Header',
                'short_desc': '',
                'options': [{
                  'type': 'checkbox',
                  'label': 'Metrics',
                  'value': true,
                  'name': 'metrics',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_1'
                }, {
                  'type': 'checkbox',
                  'label': 'Text',
                  'value': false,
                  'name': 'widget_header',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_2'
                }, {
                  'type': 'checkbox',
                  'label': 'Display industry ranking',
                  'value': true,
                  'name': 'display_industry_ranking',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_3'
                }
                ]
              },
              {
                'title': 'Widget header text',
                'short_desc': '',
                'options': [{
                  'type': 'textarea',
                  'label': 'What our customers say',
                  'value': '',
                  'name': 'widget_header_text',
                  'maxLength': 50,
                  'display_input': true,
                  'class': '',
                  'id': 'widget_header_text'
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget body',
            'prop_desc': 'Customise how you want your reviews to look and feel. ',
            'prop_option': [
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '5 Star rating',
                  'value': true,
                  'name': 'five_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'inputEvent': 'five_star_rating_color',
                  'class': '',
                  'id': 'five_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '4 Star rating',
                  'value': true,
                  'colored': 4,
                  'name': 'four_star_rating_color',
                  'display_input': true,
                  'class': '',
                  'id': 'four_star_rating_color'
                }
                ]
              },
              {
                'title': 'Number of reviews to display in widget',
                'prop_class': 'v_tab_num_of_reviews',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': '10', 'text': 10 }, { 'value': '20', 'text': 20 }, { 'value': '30', 'text': 30 }],
                  'name': 'num_of_reviews',
                  'display_input': true,
                  'class': '',
                  'id': 'num_of_reviews'
                }]
              },
              {
                'title': 'Display Reviewers name as anonymous',
                'prop_class': 'name_anonymous',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget footer',
            'prop_desc': 'Customise the display of your Write A Review button.',
            'prop_option': [
              {
                'title': 'Button colour',
                'short_desc': '',
                'prop_class': 'review_button_colors',
                'options': [{
                  'type': 'color',
                  'label': '#ffffff',
                  'value': 'left',
                  'name': 'review_button_color',
                  'display_input': false,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'class': '',
                  'id': 'review_button_color'
                }]
              },
              {
                'title': 'Button font colour',
                'prop_class': 'review_button_colors',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#ffffff',
                  'value': 'left',
                  'name': 'review_button_font_color',
                  'display_input': false,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'class': '',
                  'id': 'review_button_font_color'
                }]
              }
            ]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'The Review Tab will appear on any page that contains the code below. In order to ensure that it will load\n' +
              'on every page, please make sure every page contains this code.'
          }
        ]
      },
      reviewBadge: {
        'title': 'Verified Review Badge',
        'short_description': 'Use this badge to show your commitment to building a trusted reputation on an independent review platform that consumers trust. \n',
        'properties': [
          {
            'prop_title': 'Verified Review Badge dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '144 x 144px',
                  'value': 'desktop',
                  'display_input': false,
                  'class': 'dimensions',
                  'id': ''
                }]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '112 x 112px',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget',
            'prop_class': '',
            'prop_desc': 'Customise how you want your Verified Review Badge to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'badge_widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'badge_widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font and border colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Logo colour',
                'prop_class': 'logo_color_container',
                'short_desc': '',
                'options': [{
                  'type': 'radio_img',
                  'label': '25%',
                  'value': 'logo-transparent.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color transparent_background',
                  'img_src': '/static/img/logo-transparent.svg',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'logo_color_1'
                }, {
                  'type': 'radio_img',
                  'label': '50%',
                  'value': 'logo-white.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_2',
                  'img_src': '/static/img/logo-white.svg'
                }, {
                  'type': 'radio_img',
                  'label': '75%',
                  'value': 'logo-white_grey.svg',
                  'display_input': true,
                  'name': 'logo_color',
                  'class': 'is-checkradio logo_color blue_background',
                  'id': 'logo_color_3',
                  'img_src': '/static/img/logo-white_grey.svg'
                }, {
                  'type': 'radio_img',
                  'label': '100%',
                  'value': 'logo-white_blue.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_4',
                  'img_src': '/static/img/logo-white_blue.svg'
                }
                ]
              },
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }]
              }]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display your Verified Review Badge.'
          }
        ]
      },
      verifiedSiteBadge: {
        'title': 'Verified Badge',
        'short_description': 'As a Hellopeter verified business who instantly reassure your customers that your business is trustworthy.',
        'properties': [
          {
            'prop_title': 'Verified site badge dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '185 x 75px',
                  'value': 'desktop',
                  'display_input': false,
                  'class': 'dimensions',
                  'id': ''
                }]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '115 x 50px',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget',
            'prop_class': '',
            'prop_desc': 'Customise how you want your verified badge to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'badge_widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'badge_widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font and border colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Logo colour',
                'prop_class': 'logo_color_container',
                'short_desc': '',
                'options': [{
                  'type': 'radio_img',
                  'label': '25%',
                  'value': 'logo-transparent.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color transparent_background',
                  'img_src': '/static/img/logo-transparent.svg',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'logo_color_1'
                }, {
                  'type': 'radio_img',
                  'label': '50%',
                  'value': 'logo-white.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_2',
                  'img_src': '/static/img/logo-white.svg'
                }, {
                  'type': 'radio_img',
                  'label': '75%',
                  'value': 'logo-white_grey.svg',
                  'display_input': true,
                  'name': 'logo_color',
                  'class': 'is-checkradio logo_color blue_background',
                  'id': 'logo_color_3',
                  'img_src': '/static/img/logo-white_grey.svg'
                }, {
                  'type': 'radio_img',
                  'label': '100%',
                  'value': 'logo-white_blue.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_4',
                  'img_src': '/static/img/logo-white_blue.svg'
                }
                ]
              }]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display your Verified Badge.'
          }
        ]
      },
      verticalFeed: {
        'title': 'Vertical Feed',
        'short_description': 'A vertical feed that is customisable to your website look & feel, which shows your latest 4 and 5-star reviews. Potential consumers will be able to see why deciding on your business is a great choice to make.',
        'properties': [
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'prop_class': 'w_dimension',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': '320',
                  'display_input': true,
                  'class': 'dimensions',
                  'name': 'dimension',
                  'id': 'dimension_1'
                },
                  {
                    'type': 'radio',
                    'label': '700px width',
                    'value': '700',
                    'display_input': true,
                    'name': 'dimension',
                    'class': 'dimensions',
                    'id': 'dimension_2'
                  },
                  {
                    'type': 'radio',
                    'label': '940px width',
                    'name': 'dimension',
                    'value': '940',
                    'display_input': true,
                    'class': 'dimensions',
                    'id': 'dimension_3'
                  }
                ]
              },
              {
                'title': 'Mobile',
                'prop_class': 'w_dimension',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Metrics',
            'prop_class': 'metrics_header',
            'prop_wrapper': 'flex',
            'prop_desc': 'Customise what you want your customers to see. ',
            'prop_option': [
              {
                'title': 'Widget Header',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Metrics',
                  'value': 'metrics',
                  'name': 'widget_header',
                  'clk': 'chooseGoogleReviews',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_1'
                }, {
                  'type': 'radio',
                  'label': 'Text',
                  'value': 'text',
                  'clk': 'chooseGoogleReviews',
                  'name': 'widget_header',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_2'
                }, {
                  'type': 'checkbox',
                  'label': 'Display industry ranking',
                  'value': true,
                  'name': 'display_industry_ranking',
                  'display_input': true,
                  'class': 'widget_header_1 display_industry_rank',
                  'id': 'widget_header_3'
                }
                ]
              },
              {
                'title': 'Display metric from channels',
                'short_desc': '',
                'options': [{
                  'type': 'metrics_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_metrix',
                  'class': 'google_metrix',
                  'id': 'google_metrix',
                  'callBack': 'metricFilterMetric'
                }
                ]
              }
              ]
          },
          {
            'prop_title': 'Widget',
            'prop_class': '',
            'prop_desc': 'Customise how you want your reviews to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font and border colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'model': 'rgb',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Logo colour',
                'prop_class': 'v_feed_logo_color_container',
                'short_desc': '',
                'options': [{
                  'type': 'radio_img',
                  'label': '25%',
                  'value': 'logo-transparent.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color transparent_background',
                  'img_src': '/static/img/logo-transparent.svg',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'logo_color_1'
                }, {
                  'type': 'radio_img',
                  'label': '50%',
                  'value': 'logo-white.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_2',
                  'img_src': '/static/img/logo-white.svg'
                }, {
                  'type': 'radio_img',
                  'label': '75%',
                  'value': 'logo-white_grey.svg',
                  'display_input': true,
                  'name': 'logo_color',
                  'class': 'is-checkradio logo_color blue_background',
                  'id': 'logo_color_3',
                  'img_src': '/static/img/logo-white_grey.svg'
                }, {
                  'type': 'radio_img',
                  'label': '100%',
                  'value': 'logo-white_blue.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_4',
                  'img_src': '/static/img/logo-white_blue.svg'
                }
                ]
              },
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '5 Star rating',
                  'value': true,
                  'name': 'five_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'inputEvent': 'five_star_rating_color',
                  'class': '',
                  'id': 'five_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '4 Star rating',
                  'value': true,
                  'colored': 4,
                  'name': 'four_star_rating_color',
                  'display_input': true,
                  'class': '',
                  'id': 'four_star_rating_color'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Reviews',
            'prop_class': '',
            'prop_option': [
              {
                'title': 'Number of reviews to display in widget',
                'prop_class': 'num_of_reviews mtop-0',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': '10', 'text': 10 }, { 'value': '20', 'text': 20 }, { 'value': '30', 'text': 30 }, { 'value': '50', 'text': 50 }, { 'value': '70', 'text': 70 }],
                  'name': 'num_of_reviews',
                  'display_input': true,
                  'class': '',
                  'id': 'num_of_reviews'
                }]
              },
              {
                'title': 'Display Reviewers name as anonymous',
                'prop_class': 'name_anonymous mtop-0',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              },
              {
                'title': 'Display reviews from channels',
                'short_desc': '',
                'options': [{
                  'type': 'reviews_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_reviews',
                  'class': 'google_reviews',
                  'id': 'google_reviews'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display your reviews. '
          }
        ]
      },
      reviewSlider: {
        'title': 'Review Slider',
        'short_description': 'This Review Slider contains a small tab that can be placed on your screen that is expandable on clicking, to reveal all your reviews.',
        'properties': [
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'prop_class': 'w_dimension',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': '320',
                  'display_input': true,
                  'class': 'dimensions',
                  'name': 'dimension',
                  'id': 'dimension_1'
                },
                  {
                    'type': 'radio',
                    'label': '700px width',
                    'value': '700',
                    'display_input': true,
                    'name': 'dimension',
                    'class': 'dimensions',
                    'id': 'dimension_2'
                  },
                  {
                    'type': 'radio',
                    'label': '940px width',
                    'name': 'dimension',
                    'value': '940',
                    'display_input': true,
                    'class': 'dimensions',
                    'id': 'dimension_3'
                  }
                ]
              },
              {
                'title': 'Mobile',
                'prop_class': 'w_dimension',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Reviews',
            'prop_class': '',
            'prop_option': [
              {
                'title': 'Number of reviews to display in widget',
                'prop_class': 'num_of_reviews mtop-0',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': '10', 'text': 10 }, { 'value': '20', 'text': 20 }, { 'value': '30', 'text': 30 }, { 'value': '50', 'text': 50 }, { 'value': '70', 'text': 70 }],
                  'name': 'num_of_reviews',
                  'display_input': true,
                  'class': '',
                  'id': 'num_of_reviews'
                }]
              },
              {
                'title': 'Display Reviewers name as anonymous',
                'prop_class': 'name_anonymous mtop-0',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              },
              {
                'title': 'Display reviews from channels',
                'short_desc': '',
                'options': [{
                  'type': 'reviews_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_reviews',
                  'class': 'google_reviews',
                  'id': 'google_reviews'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Widget body ',
            'prop_class': '',
            'prop_desc': 'Customise how you want your reviews to look and feel.',
            'prop_option': [
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '5 Star rating',
                  'value': true,
                  'name': 'five_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'inputEvent': 'five_star_rating_color',
                  'class': '',
                  'id': 'five_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '4 Star rating',
                  'value': true,
                  'colored': 4,
                  'name': 'four_star_rating_color',
                  'display_input': true,
                  'class': '',
                  'id': 'four_star_rating_color'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'The Review Slider will appear on any page that contains the code below. In order to ensure that it will load\n' +
              'on every page, please make sure every page contains this code.'
          }
        ]
      },
      carousel: {
        'title': 'Carousel',
        'short_description': 'The Carousel widget allows users to cycle through your latest reviews and is perfect for desktop and mobile sites. ',
        'properties': [
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'prop_class': 'w_dimension',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': '320',
                  'display_input': true,
                  'class': 'dimensions',
                  'name': 'dimension',
                  'id': 'dimension_1'
                },
                  {
                    'type': 'radio',
                    'label': '700px width',
                    'value': '700',
                    'display_input': true,
                    'name': 'dimension',
                    'class': 'dimensions',
                    'id': 'dimension_2'
                  },
                  {
                    'type': 'radio',
                    'label': '940px width',
                    'name': 'dimension',
                    'value': '940',
                    'display_input': true,
                    'class': 'dimensions',
                    'id': 'dimension_3'
                  }
                ]
              },
              {
                'title': 'Mobile',
                'prop_class': 'w_dimension',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Metrics',
            'prop_class': 'metrics_header',
            'prop_wrapper': 'flex',
            'prop_desc': 'Customise what you want your customers to see. ',
            'prop_option': [
              {
                'title': 'Widget Header',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Metrics',
                  'value': 'metrics',
                  'name': 'widget_header',
                  'display_input': true,
                  'clk': 'chooseGoogleReviews',
                  'class': 'widget_header_1',
                  'id': 'widget_header_1'
                }, {
                  'type': 'radio',
                  'label': 'Text',
                  'value': 'text',
                  'clk': 'chooseGoogleReviews',
                  'name': 'widget_header',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_2'
                }, {
                  'type': 'checkbox',
                  'label': 'Display industry ranking',
                  'value': true,
                  'name': 'display_industry_ranking',
                  'display_input': true,
                  'class': 'widget_header_1 display_industry_rank',
                  'id': 'widget_header_3'
                }
                ]},
              {
                'title': 'Display metric from channels',
                'short_desc': '',
                'options': [{
                  'type': 'metrics_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_metrix',
                  'class': 'google_metrix',
                  'id': 'google_metrix',
                  'callBack': 'metricFilterMetric'
                }
                ]
              }]
          },
          {
            'prop_title': 'Widget',
            'prop_class': '',
            'prop_desc': 'Customise how you want your reviews to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font and border colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'model': 'rgb',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Logo colour',
                'prop_class': 'v_feed_logo_color_container',
                'short_desc': '',
                'options': [{
                  'type': 'radio_img',
                  'label': '25%',
                  'value': 'logo-transparent.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color transparent_background',
                  'img_src': '/static/img/logo-transparent.svg',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'logo_color_1'
                }, {
                  'type': 'radio_img',
                  'label': '50%',
                  'value': 'logo-white.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_2',
                  'img_src': '/static/img/logo-white.svg'
                }, {
                  'type': 'radio_img',
                  'label': '75%',
                  'value': 'logo-white_grey.svg',
                  'display_input': true,
                  'name': 'logo_color',
                  'class': 'is-checkradio logo_color blue_background',
                  'id': 'logo_color_3',
                  'img_src': '/static/img/logo-white_grey.svg'
                }, {
                  'type': 'radio_img',
                  'label': '100%',
                  'value': 'logo-white_blue.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_4',
                  'img_src': '/static/img/logo-white_blue.svg'
                }
                ]
              },
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '5 Star rating',
                  'value': true,
                  'name': 'five_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'inputEvent': 'five_star_rating_color',
                  'class': '',
                  'id': 'five_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '4 Star rating',
                  'value': true,
                  'colored': 4,
                  'name': 'four_star_rating_color',
                  'display_input': true,
                  'class': '',
                  'id': 'four_star_rating_color'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Reviews',
            'prop_class': '',
            'prop_option': [
              {
                'title': 'Number of reviews to display in widget',
                'prop_class': 'num_of_reviews mtop-0',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': '10', 'text': 10 }, { 'value': '20', 'text': 20 }, { 'value': '30', 'text': 30 }],
                  'name': 'num_of_reviews',
                  'display_input': true,
                  'class': '',
                  'id': 'num_of_reviews'
                }]
              },
              {
                'title': 'Display Reviewers name as anonymous',
                'prop_class': 'name_anonymous mtop-0',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              },
              {
                'title': 'Display reviews from channels',
                'short_desc': '',
                'options': [{
                  'type': 'reviews_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_reviews',
                  'class': 'google_reviews',
                  'id': 'google_reviews'
                }/*,
                {
                  'type': 'reviews_channel',
                  'label': '',
                  'value': '',
                  'name': 'facebook_reviews',
                  'class': 'facebook_reviews',
                  'id': 'facebook_reviews'
                } */
                ]
              }
            ]
          },

          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display your reviews. '
          }
        ]
      },
      onSiteWriteReview: {
        'title': 'On-site write A review Button',
        'short_description': 'The Write A Review button or text link can be displayed on any page of your site. Clicking the Write A Review button or text link will open a review collection form in the centre of the screen which allows you to collect reviews directly from your site.',
        'properties': [
          {
            'prop_title': '',
            'prop_class': 'widget_type',
            'prop_option': [
              {
                'title': '',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Reviews Button',
                  'value': 'button',
                  'name': 'widget_type',
                  'display_input': true,
                  'allowedDisable': false,
                  'class': 'dimensions',
                  'id': ''
                }]
              },
              {
                'title': '',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Review text link',
                  'value': 'link',
                  'name': 'widget_type',
                  'display_input': true,
                  'allowedDisable': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions_txt',
            'prop_title_hide': true,
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'options': [{
                  'type': 'text',
                  'name': 'desktop_width',
                  'label': '',
                  'value': '130',
                  'display_input': true,
                  'class': 'dimensions dimension_txt desktop_width_input',
                  'id': 'desktop_width'
                }, {
                  'type': 'text',
                  'label': 'px',
                  'value': '35',
                  'name': 'desktop_height',
                  'display_input': true,
                  'class': 'dimensions dimension_txt',
                  'id': 'desktop_height'
                }
                ]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '130px X 35px',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Review Button',
            'prop_class': 'review_button',
            'prop_desc': 'Customise the display of your Review Button.',
            'prop_option': [
              {
                'title': 'Button colour',
                'prop_class': 'tab_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'tab_color',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'tab_color',
                  'id': ''
                }]
              },
              {
                'title': 'Button opacity',
                'prop_class': 'tab_opacity',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '25%',
                  'value': 25,
                  'name': 'tab_opacity',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'allowedDisable': true,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': '50%',
                  'value': 50,
                  'name': 'tab_opacity',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'allowedDisable': true,
                  'id': 'tab_opacity_2'
                }, {
                  'type': 'radio',
                  'label': '75%',
                  'value': 75,
                  'display_input': true,
                  'name': 'tab_opacity',
                  'class': 'is-checkradio',
                  'allowedDisable': true,
                  'id': 'tab_opacity_3'
                }, {
                  'type': 'radio',
                  'label': '100%',
                  'value': 100,
                  'name': 'tab_opacity',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'allowedDisable': true,
                  'id': 'tab_opacity_4'
                }
                ]
              },
              {
                'title': 'Button text',
                'short_desc': '',
                'prop_class': 'btn_txt_container',
                'options': [{
                  'type': 'text',
                  'label': '',
                  'display_input': true,
                  'name': 'btn_text',
                  'class': 'btn_txt',
                  'id': 'btn_txt'
                }]
              },
              {
                'title': 'Button font',
                'prop_class': 'btn_font',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': 'arial', 'text': 'Arial' }, { 'value': 'Open Sans', 'text': 'Open Sans' }, { 'value': 'sans serif', 'text': 'Sans Serif' }, { 'value': 'verdana', 'text': 'Verdana' }, { 'value': 'helvetica', 'text': 'Helvetica' }],
                  'name': 'btn_font_family',
                  'display_input': true,
                  'class': 'btn_font_control',
                  'id': 'btn_font_control'
                }]
              },
              {
                'title': 'Button font size',
                'prop_class': 'font-size-container',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': '12px', 'text': '12px' }, { 'value': '14px', 'text': '14px' }, { 'value': '16px', 'text': '16px' }],
                  'name': 'btn_font_size',
                  'display_input': true,
                  'class': 'btn_size',
                  'id': 'num_of_reviews'
                }]
              },
              {
                'title': 'Button font colour',
                'prop_class': 'font-color-container',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#ffffff',
                  'value': 'left',
                  'name': 'font_color',
                  'display_input': false,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'class': 'font_color',
                  'id': 'font_color'
                }]
              }

            ]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to start collecting reviews directly from your website.',
            'prop_class': 'clear'
          }
        ]
      },
      metricDisplayBadge: {
        'title': 'Metric Display Badge',
        'short_description': 'Allow your customers to see a summary of your Hellopeter review metrics.\n',
        'properties': [
          {
            'prop_title': 'Metric Display Badge dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '190 x 105px',
                  'value': 'desktop',
                  'display_input': false,
                  'class': 'dimensions',
                  'id': ''
                }]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '165 x 85px',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Metrics',
            'prop_class': 'widget_header',
            'prop_wrapper': 'flex',
            'prop_desc': 'Customise what you want your customers to see. ',
            'prop_option': [
              {
                'title': '',
                'short_desc': '',
                'options': [{
                  'type': 'checkbox',
                  'label': 'Display industry ranking',
                  'value': true,
                  'name': 'display_industry_rank',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_3'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Widget',
            'prop_class': '',
            'prop_desc': 'Customise how you want your Metric Display Badge to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'badge_widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'badge_widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font and border colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Logo colour',
                'prop_class': 'logo_color_container',
                'short_desc': '',
                'options': [{
                  'type': 'radio_img',
                  'label': '25%',
                  'value': 'logo-transparent.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color transparent_background',
                  'img_src': '/static/img/logo-transparent.svg',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'logo_color_1'
                }, {
                  'type': 'radio_img',
                  'label': '50%',
                  'value': 'logo-white.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_2',
                  'img_src': '/static/img/logo-white.svg'
                }, {
                  'type': 'radio_img',
                  'label': '75%',
                  'value': 'logo-white_grey.svg',
                  'display_input': true,
                  'name': 'logo_color',
                  'class': 'is-checkradio logo_color blue_background',
                  'id': 'logo_color_3',
                  'img_src': '/static/img/logo-white_grey.svg'
                }, {
                  'type': 'radio_img',
                  'label': '100%',
                  'value': 'logo-white_blue.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_4',
                  'img_src': '/static/img/logo-white_blue.svg'
                }
                ]
              },
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }]
              }]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display a summary of your Hellopeter review metrics.'
          }
        ]
      },
      seoPage: {
        'title': 'SEO Review Page',
        'short_description': 'The SEO Page is a dedicated page for all your reviews. When consumers search for your business in Google, they’ll be more likely to land on your website. ',
        'properties': [
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'prop_class': 'w_dimension',
                'options': [
                  {
                    'type': 'radio',
                    'label': '700px width',
                    'value': '700',
                    'display_input': true,
                    'name': 'dimension',
                    'class': 'dimensions',
                    'id': 'dimension_2'
                  },
                  {
                    'type': 'radio',
                    'label': '960px width',
                    'name': 'dimension',
                    'value': '960',
                    'display_input': true,
                    'class': 'dimensions',
                    'id': 'dimension_3'
                  },
                  {
                    'type': 'radio',
                    'label': '1200px width',
                    'name': 'dimension',
                    'value': '1200',
                    'display_input': true,
                    'class': 'dimensions',
                    'id': 'dimension_4'
                  }
                ]
              },
              {
                'title': 'Mobile',
                'prop_class': 'w_dimension',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '320px width',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget header',
            'prop_class': 'metrics_header',
            'prop_wrapper': 'flex',
            'prop_desc': 'Customise the header of your widget to what you want your customers to see.  ',
            'prop_option': [
              {
                'title': 'Widget Header',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Metrics',
                  'value': 'metrics',
                  'name': 'widget_header',
                  'clk': 'chooseGoogleReviews',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_1'
                }, {
                  'type': 'radio',
                  'label': 'Text',
                  'value': 'text',
                  'clk': 'chooseGoogleReviews',
                  'name': 'widget_header',
                  'display_input': true,
                  'class': 'widget_header_1',
                  'id': 'widget_header_2'
                }
                // }, {
                //   'type': 'checkbox',
                //   'label': 'Display industry ranking',
                //   'value': true,
                //   'name': 'display_industry_ranking',
                //   'display_input': true,
                //   'class': 'widget_header_1 display_industry_rank',
                //   'id': 'widget_header_3'
                // }
                ]
              },
              {
                'title': 'Display metric from channels',
                'short_desc': '',
                'options': [{
                  'type': 'metrics_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_metrix',
                  'class': 'google_metrix',
                  'id': 'google_metrix',
                  'callBack': 'metricFilterMetric'
                }
                ]
              },
              {
                'title': 'Widget header text',
                'short_desc': '',
                'options': [{
                  'type': 'textarea',
                  'label': 'What our customers say',
                  'value': '',
                  'name': 'widget_header_text',
                  'maxLength': 50,
                  'display_input': true,
                  'class': '',
                  'id': 'widget_header_text'
                }]}
            ]
          },
          {
            'prop_title': 'Widget body',
            'prop_class': '',
            'prop_desc': 'Customise how you want your reviews to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'model': 'rgb',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '5 Star rating',
                  'value': true,
                  'name': 'five_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'inputEvent': 'five_star_rating_color',
                  'class': '',
                  'id': 'five_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '4 Star rating',
                  'value': true,
                  'colored': 4,
                  'name': 'four_star_rating_color',
                  'display_input': true,
                  'class': '',
                  'id': 'four_star_rating_color'
                },
                  {
                    'type': 'star-rating',
                    'label': '3 Star rating',
                    'value': true,
                    'colored': 3,
                    'name': 'three_star_rating_color',
                    'display_input': true,
                    'class': '',
                    'id': 'three_star_rating_color'
                  }
                ]
              }
            ]
          },
          {
            'prop_title': 'Reviews',
            'prop_class': '',
            'prop_desc': '',
            'prop_option': [
              {
                'title': 'Display Reviewers name as anonymous',
                'prop_class': 'name_anonymous',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              },
              {
                'title': 'Display replies',
                'prop_class': 'display_replies',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'display_replies',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'display_reply_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'display_replies',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'display_reply_2'
                }]
              },
              {
                'title': 'Display reviews from channels',
                'short_desc': '',
                'options': [{
                  'type': 'reviews_channel',
                  'label': '',
                  'value': '',
                  'name': 'google_reviews',
                  'class': 'google_reviews',
                  'id': 'google_reviews'
                }
                ]
              }
            ]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'To showcase reviews in a dedicated SEO Page on your site, add this code to the HTML of the desired page.'
          }
        ]
      },
      dropDown: {
        'title': 'Drop-down',
        'short_description': 'The Drop-down widget is great if you don’t want to take up too much space on your site. The widget expands when a web visitor clicks on it to reveal the review content.\n',
        'properties': [
          {
            'prop_title': 'Widget dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'prop_class': 'w_dimension',
                'options': [
                  {
                    'type': 'radio',
                    'label': '320px width',
                    'value': '320',
                    'display_input': true,
                    'name': 'dimension',
                    'class': 'dimensions',
                    'id': 'dimension_2'
                  },
                  {
                    'type': 'radio',
                    'label': '460px width',
                    'name': 'dimension',
                    'value': '460',
                    'display_input': true,
                    'class': 'dimensions',
                    'id': 'dimension_3'
                  }]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'prop_class': 'w_dimension',
                'options': [{
                  'type': 'radio',
                  'label': '180px width',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget',
            'prop_desc': 'Customise how you want your reviews to look and feel. ',
            'prop_option': [
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '5 Star rating',
                  'value': true,
                  'name': 'five_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'inputEvent': 'five_star_rating_color',
                  'class': '',
                  'id': 'five_star_rating_color'
                }, {
                  'type': 'star-rating',
                  'label': '4 Star rating',
                  'value': true,
                  'colored': 4,
                  'name': 'four_star_rating_color',
                  'display_input': true,
                  'class': '',
                  'id': 'four_star_rating_color'
                }
                ]
              },
              {
                'title': 'Number of reviews to display in widget',
                'prop_class': 'v_tab_num_of_reviews',
                'short_desc': '',
                'options': [{
                  'type': 'select',
                  'label': '',
                  'values': [{ 'value': '10', 'text': 10 }, { 'value': '20', 'text': 20 }, { 'value': '30', 'text': 30 }],
                  'name': 'num_of_reviews',
                  'display_input': true,
                  'class': '',
                  'id': 'num_of_reviews'
                }]
              },
              {
                'title': 'Display Reviewers name as anonymous',
                'prop_class': 'name_anonymous',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'reviewers_name_as_anonymous',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              },
              {
                'title': 'Show Write A Review button',
                'prop_class': 'display_write_review_btn',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Yes',
                  'value': true,
                  'name': 'display_write_review_btn',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'tab_opacity_1'
                }, {
                  'type': 'radio',
                  'label': 'No',
                  'value': false,
                  'name': 'display_write_review_btn',
                  'display_input': true,
                  'class': 'is-checkradio',
                  'id': 'tab_opacity_2'
                }]
              },
              {
                'title': 'Button colour',
                'short_desc': '',
                'prop_class': 'review_button_colors',
                'options': [{
                  'type': 'color',
                  'label': '#ffffff',
                  'value': 'left',
                  'name': 'review_button_color',
                  'display_input': false,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'class': '',
                  'id': 'review_button_color'
                }]
              },
              {
                'title': 'Button font colour',
                'prop_class': 'review_button_colors',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#ffffff',
                  'value': 'left',
                  'name': 'review_button_font_color',
                  'display_input': false,
                  'beforeHtml': '',
                  'afterHtml': '',
                  'class': '',
                  'id': 'review_button_font_color'
                }]
              }
            ]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display your reviews.'
          }
        ]
      },
      businessStats:
        {
          'title': 'Business metrics ribbon'
        },
      fullStar:
        {
          'title': 'Star rating'
        },
      trustIndex: {
        'title': 'TrustIndex badge'
      },
      topReviews: {
        'title': 'Review feed'
      },
      carousels: {
        'title': 'Collect reviews carousel'
      },
      ribbonBadge: {
        'title': 'Ribbon Badge',
        'short_description': 'Use this badge to show that you care about your customer’s feedback.',
        'properties': [
          {
            'prop_title': 'Ribbon badge dimensions',
            'prop_class': 'widget_dimensions',
            'prop_option': [
              {
                'title': 'Desktop',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '260 x 60px',
                  'value': 'desktop',
                  'display_input': false,
                  'class': 'dimensions',
                  'id': ''
                }]
              },
              {
                'title': 'Mobile',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': '220 x 50px',
                  'value': 'mobile',
                  'display_input': false,
                  'class': '',
                  'id': ''
                }]
              }
            ]
          },
          {
            'prop_title': 'Widget',
            'prop_class': '',
            'prop_desc': 'Customise how you want your Ribbon Badge to look and feel.',
            'prop_option': [
              {
                'title': 'Widget background colour',
                'short_desc': '',
                'options': [{
                  'type': 'radio',
                  'label': 'Original ',
                  'sub_label': '(default)',
                  'value': 'original',
                  'name': 'widget_background_color',
                  'clk': 'checkBackground',
                  'display_input': true,
                  'class': 'badge_widget_background_color ',
                  'id': ''
                }, {
                  'type': 'radio',
                  'label': 'Transparent',
                  'value': 'transparent',
                  'display_input': true,
                  'clk': 'checkBackground',
                  'name': 'widget_background_color',
                  'class': 'badge_widget_background_color',
                  'id': ''
                }
                ]
              },
              {
                'title': 'Font and border colour',
                'prop_class': 'font_border_color',
                'short_desc': '',
                'options': [{
                  'type': 'color',
                  'label': '#bababa',
                  'value': 'left',
                  'beforeHtml': '',
                  'name': 'font_color',
                  'afterHtml': '',
                  'display_input': false,
                  'class': 'font_border_color',
                  'id': ''
                }]
              },
              {
                'title': 'Logo colour',
                'prop_class': 'logo_color_container',
                'short_desc': '',
                'options': [{
                  'type': 'radio_img',
                  'label': '25%',
                  'value': 'logo-transparent.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color transparent_background',
                  'img_src': '/static/img/logo-transparent.svg',
                  'beforeHtml': '',
                  'afterHtml': '',
                  'id': 'logo_color_1'
                }, {
                  'type': 'radio_img',
                  'label': '50%',
                  'value': 'logo-white.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_2',
                  'img_src': '/static/img/logo-white.svg'
                }, {
                  'type': 'radio_img',
                  'label': '75%',
                  'value': 'logo-white_grey.svg',
                  'display_input': true,
                  'name': 'logo_color',
                  'class': 'is-checkradio logo_color blue_background',
                  'id': 'logo_color_3',
                  'img_src': '/static/img/logo-white_grey.svg'
                }, {
                  'type': 'radio_img',
                  'label': '100%',
                  'value': 'logo-white_blue.svg',
                  'name': 'logo_color',
                  'display_input': true,
                  'class': 'is-checkradio logo_color grey_background',
                  'id': 'logo_color_4',
                  'img_src': '/static/img/logo-white_blue.svg'
                }
                ]
              },
              {
                'title': 'Star rating colour',
                'short_desc': '',
                'options': [{
                  'type': 'star-rating',
                  'label': 'Average star rating',
                  'value': true,
                  'name': 'average_star_rating_color',
                  'display_input': true,
                  'colored': 5,
                  'class': '',
                  'id': 'average_star_rating_color'
                }]
              }]
          },
          {
            'prop_title': 'Html code',
            'prop_desc': 'Copy and add this HTML code to your website to display your Ribbon Badge.'
          }
        ]
      }
    }
  },
  methods: {
    getWidget () {
      let presentWidget = this.$route.params.type
      this.widgetsProperties = this[presentWidget]
      return this.widgetsProperties
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/widgets-collection.js